import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_ShiftReduceParsers = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Shift Reduce Parsers"
    videos={[
      "https://www.youtube.com/embed/Ow7XXOmnNLo",
    ]}
    takeaways={[]}
    questions={[
      `1) Consider the given grammar. Perform shift-reduce parsing of the input string "id1+id2+id3*id4".

E -> E + E
E -> E * E
E -> id`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_ShiftReduceParsers;
